import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FundsPortalService, LocalStorageService } from 'src/app/core/core.module';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less']
})
export class ForgotPasswordComponent implements OnInit {
  
  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;
  
  public searchFormGroup!: FormGroup; 

  public openNav: boolean = false;
  public clickOutside: boolean = false;
  public isErrorEmail: boolean = false;
  public isErrorCompanyCode: boolean = false;
  public emailRegex: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';

  constructor(
    private renderer: Renderer2,
    public router: Router,
    public fundsPortalService: FundsPortalService,
    public localStorageService: LocalStorageService
  ) { 
    
  }

  ngOnInit(): void {
    this.initializeFormGroup();
    this.onChangeValueEmail();
  }

  //#region Form Group Events
  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      companyCode: new FormControl('', [Validators.required])
    });
  }

  onChangeValueEmail(): void {
    const control = this.searchFormGroup.get('email');
    control?.valueChanges.subscribe(value => {
      if (value) {
        this.isErrorEmail = false;

      } else if(!value.valid  && control.touched){

        this.isErrorEmail =true;      
      }
    });
  }

  proceed(): void {
    var email = this.searchFormGroup.get('email');
    var companyCode = this.searchFormGroup.get('companyCode');

    if (!email?.valid || !companyCode?.valid) {
        email?.markAsTouched();
        companyCode?.markAsTouched();
        this.isErrorEmail = !email?.valid;
        this.isErrorCompanyCode = !companyCode?.valid;
        return;
    }
    else{
      this.isErrorEmail = false;
      this.isErrorCompanyCode = false;
      const body = {
        email: this.searchFormGroup.get('email')?.value,
        company_code: this.searchFormGroup.get('companyCode')?.value
      };

      this.localStorageService.set('forgot_password_email', body.email, 900);
      this.localStorageService.set('forgot_password_company_code', body.company_code, 900);

      this.fundsPortalService.postForgotPasswordStart(body).subscribe({
        next: (data: any) => {
          if (data?.response_result !== '0001') {
            this.showStartFlowInfo(data);
            return;
          }

          if (this.shouldUseChallengeFlow(data)) {
            this.localStorageService.set('forgot_password_email', this.searchFormGroup.get('email')?.value, 900);
            this.localStorageService.set('forgot_password_company_code', this.searchFormGroup.get('companyCode')?.value, 900);
            this.router.navigateByUrl('/forgot-password/challenge-verify', { skipLocationChange: false });
            return;
          }

          if (this.shouldUseMfaFlow(data)) {
            this.localStorageService.set('forgot_password_email', this.searchFormGroup.get('email')?.value, 900);
            this.localStorageService.set('forgot_password_company_code', this.searchFormGroup.get('companyCode')?.value, 900);
            this.router.navigateByUrl('/forgot-password/mfa-verify', { skipLocationChange: false });
            return;
          }

          this.showStartFlowInfo(data);
        },
        error: (error: any) => {
          if (this.shouldUseChallengeFlow(error)) {
            this.localStorageService.set('forgot_password_email', this.searchFormGroup.get('email')?.value, 900);
            this.localStorageService.set('forgot_password_company_code', this.searchFormGroup.get('companyCode')?.value, 900);
            this.router.navigateByUrl('/forgot-password/challenge-verify', { skipLocationChange: false });
            return;
          }

          if (this.shouldUseMfaFlow(error)) {
            this.localStorageService.set('forgot_password_email', this.searchFormGroup.get('email')?.value, 900);
            this.localStorageService.set('forgot_password_company_code', this.searchFormGroup.get('companyCode')?.value, 900);
            this.router.navigateByUrl('/forgot-password/mfa-verify', { skipLocationChange: false });
            return;
          }

          this.showStartFlowInfo(error);
        }
      });
    }
  }

  private showStartFlowInfo(response: any): void {
    this.atramModal.show();
    this.atramModal.size = 'sm';
    this.atramModal.status = 'success';
    this.atramModal.headerText = 'Check your details';
    this.atramModal.bodyText = 'If the account can be verified, the next step will be sent.';
    this.atramModal.okButtonText = 'Next';
    this.atramModal.showCancelButton = false;
    this.atramModal.showCloseButton = true;
    this.atramModal.confirmationSubject.subscribe(() => {
      this.atramModal.hide();
      this.router.navigateByUrl('/forgot-password/verify', { skipLocationChange: false });
    });
  }

  private shouldUseMfaFlow(response: any): boolean {
    const responseData = response?.response_data || {};
    const nextStep = (responseData?.next_step || responseData?.nextStep || '').toString().toLowerCase();

    if (nextStep === 'verify_mfa' || nextStep === 'mfa') {
      return true;
    }

    return responseData?.mfa_required === true || responseData?.requires_mfa === true;
  }

  private shouldUseChallengeFlow(response: any): boolean {
    const responseData = response?.response_data || {};
    const nextStep = (responseData?.next_step || responseData?.nextStep || '').toString().toLowerCase();

    if (nextStep === 'verify_challenge' || nextStep === 'challenge') {
      return true;
    }

    return responseData?.challenge_required === true || responseData?.requires_challenge === true;
  }

  goToSignIn(){
    this.router.navigateByUrl(``, { skipLocationChange: false });
  }

}
